import { Component } from '@angular/core';

@Component({
  selector: 'app-booking-dashboard',
  imports: [],
  template: `
    <p>
      booking-dashboard works!
    </p>
  `,
  styles: ``
})
export class BookingDashboardComponent {

}
